import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { onlyOnePlayingPlayerAtom } from "~/lib/only-one-playing-player";

export const useOnlyOnePlayingPlayerEffect = () => {
  const {
    adsManager,
    articleSpeechifyPlayer,
    playingYoutubePlayer,
    shouldPauseAd,
    shouldPauseArticleSpeechifyPlayer,
    shouldPauseYouTubePlayer,
  } = useAtomValue(onlyOnePlayingPlayerAtom);

  useEffect(() => {
    if (!shouldPauseAd) {
      return;
    }

    adsManager?.pause();
  }, [adsManager, shouldPauseAd]);

  useEffect(() => {
    if (!shouldPauseArticleSpeechifyPlayer) {
      return;
    }

    articleSpeechifyPlayer?.pause();
  }, [articleSpeechifyPlayer, shouldPauseArticleSpeechifyPlayer]);

  useEffect(() => {
    if (!shouldPauseYouTubePlayer) {
      return;
    }

    try {
      void playingYoutubePlayer?.pauseVideo();
    } catch (error) {
      console.error("useOnlyOnePlayingPlayerEffect playingYoutubePlayer pauseVideo", error);
    }
  }, [playingYoutubePlayer, shouldPauseYouTubePlayer]);
};
